export default __webpack_public_path__ + "static/media/2.990249a0.png";